<template>
	<v-flex d-flex v-bind="bind">
		<v-card :color="'grey lighten-' + lighten" class="d-flex justify-center align-center">
			<v-card-text>
				<strong>
					{{text}}
				</strong>
			</v-card-text>
		</v-card>
	</v-flex>
</template>

<script>
	export default {
		name: "FinancialTableElement",

		computed: {
			bind() {
				var res = {};
				res["xs" + this.xs] = true;
				return res;
			},
		},

		props: {
			text: {},
			lighten: {},
			xs: {},
		},
	};
</script>
